import type {Dispatch, ThunkAction} from 'src/reducers';
import * as reduxApi from 'src/utils/redux-api-v2';


export const markOnboardingComplete =
  (): ThunkAction<unknown> => (dispatch: Dispatch) =>
    dispatch(reduxApi.post('onboard/mark-onboarding-completed', {}));
